import React from "react";
import {getFullCountriesList, getShortCountriesList} from "~/utils";

const shortCountriesList = getShortCountriesList();

export default function CountryName({code, ...props}) {
  const [countryName, setCountryName] = React.useState(
    shortCountriesList[code] || code
  );

  React.useEffect(() => {
    if (!(code in shortCountriesList)) {
      getFullCountriesList().then((countries) => {
        setCountryName(countries[code] || code);
      })
    }
  }, [code, setCountryName]);


  return (
    <span {...props}>{countryName}</span>
  )
}
